import { __assign } from "tslib";
export var contentScopeSettingsApiRelativePath = "/helpcenter/contentScope";
export var localesSettingsApiRelativePath = "/helpcenter/locales";
export var createContentVisibilityApi = function (baseUrl, http) {
    var scopeApiUrl = "".concat(baseUrl).concat(contentScopeSettingsApiRelativePath);
    var localesApiUrl = "".concat(baseUrl).concat(localesSettingsApiRelativePath);
    return {
        getLocaleContentSettings: function (dto) {
            return http.get("".concat(scopeApiUrl, "/").concat(dto.locale).concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        updateLocaleContentSettings: function (dto) {
            return http.put("".concat(scopeApiUrl, "/").concat(dto.locale), dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        },
        getEnabledLocales: function (brandId) { return http.get("".concat(localesApiUrl, "/enabled").concat(brandId ? "?brandId=".concat(brandId) : '')); },
        enableLocale: function (dto) {
            return http.put("".concat(localesApiUrl, "/").concat(dto.locale, "/enable").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''), {});
        },
        disableLocale: function (dto) {
            return http.put("".concat(localesApiUrl, "/").concat(dto.locale, "/disable").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''), {});
        }
    };
};
//# sourceMappingURL=index.js.map